import logger from '../../../../lib/logger/logger';
/**
 * Adds event listener tfor errors from the chatbot child frame.
 */

export var addErrorEvent = function addErrorEvent() {
  window.WFUI_BRIDGE.registerEventListener('error', function (_ref) {
    var data = _ref.data;
    logger.error(JSON.stringify(data, null, '\t'));
  }, window.WF_CHATBOT.uuid);
};